import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Note } from '../model/note';
import { HttpInternalService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class NotesService {

  private readonly _changed = new Subject<string>();

  /**
   * The id of a record whose notes just changed. Lists that show note counts
   * read them from their own payload, so they need telling when a note is
   * written, edited or deleted in a panel on top of them.
   */
  get changed$(): Observable<string> {
    return this._changed.asObservable();
  }

  notifyChanged(recordId: string): void {
    if (recordId) {
      this._changed.next(recordId);
    }
  }

  constructor(private readonly _httpService: HttpInternalService) { }

  getNotesByOrganizationId(recordId: string, organizationId: string) {
    return this._httpService.getRequest<Note[]>('Notes/GetNotesByOrganizationIdAsync', { recordId: recordId, organizationId: organizationId });
  }

  createNote(note: Note) {
    return this._httpService.postRequest<Note>('Notes/CreateNote', note);
  }

  CreateNotes(note: Note) {
    return this._httpService.postRequest<Note>('Notes/CreateNotes', note);
  }

  /** Rewrites the body of a note the signed-in user wrote. */
  updateNote(noteId: string, note: Partial<Note>) {
    return this._httpService.putRequest<Note>('Notes/UpdateNote', { noteId: noteId, ...note });
  }

  deleteNote(noteId: string, organizationId: string) {
    return this._httpService.deleteRequest<any>('Notes/DeleteNote', { noteId: noteId, organizationId: organizationId });
  }

}
